import React, { useState } from "react";
import { Icon, Input, Dropdown } from "semantic-ui-react";
import { map } from "lodash";

import styles from "./EmployeesDropdown.module.css";

export const EmployeesDropdown = ({
  text,
  value,
  list,
  selectedValues,
  onChange
}) => {
  const [searchQuery, setSearchQuery] = useState("");

  const filtered = options =>
    options?.filter(item =>
      item.text.toLowerCase().includes(searchQuery.toLowerCase())
    );

  return (
    <Dropdown
      closeOnChange={false}
      selection
      fluid
      multiple
      search
      onClose={() => setSearchQuery("")}
      text={text}
      placeholder="Select"
      value={value}
      icon={<Icon name="chevron down" />}
      className={styles.dropdown}
    >
      <Dropdown.Menu className={styles.menuContainer}>
        <div className={styles.searchContainer}>
          <Input
            placeholder="Search"
            icon="search"
            iconPosition="left"
            className={styles.searchInput}
            onClick={e => e.stopPropagation()}
            onKeyDown={e => e.stopPropagation()}
            onChange={e => setSearchQuery(e.target.value)}
            value={searchQuery}
          />
        </div>
        <Dropdown.Menu scrolling className={styles.listMenu}>
          {map(
            (filtered(list) || list).sort((a, b) => {
              const aSelected = selectedValues.includes(a.value);
              const bSelected = selectedValues.includes(b.value);

              if (aSelected && !bSelected) return -1;
              if (!aSelected && bSelected) return 1;

              const nameA = a.label?.trim().toLowerCase();
              const nameB = b.label?.trim().toLowerCase();

              if (nameA < nameB) return -1;
              if (nameA > nameB) return 1;

              return 0;
            }),
            option => (
              <Dropdown.Item
                key={option?.value}
                value={option?.value}
                text={option?.text}
                className={
                  selectedValues.includes(option?.value) ? styles.active : ""
                }
                onClick={(_, { value }) => onChange(value)}
              />
            )
          )}
        </Dropdown.Menu>
      </Dropdown.Menu>
    </Dropdown>
  );
};
